import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AiBubbleStateService {
  private sourceSignal = signal<AIGenerationBubbleSource | null>(null);

  setSource(source: AIGenerationBubbleSource) {
    this.sourceSignal.set(source);
  }

  getSource() {
    return this.sourceSignal();
  }

  clearSource() {
    this.sourceSignal.set(null);
  }
}

export enum AIGenerationBubbleSource {
  toolbar = 'toolbar',
  sidebar = 'sidebar',
}
